// extracted by mini-css-extract-plugin
module.exports = {"section":"PageHero_section__i4quK"};